import { render, staticRenderFns } from "./tdpcontactrptfrm.vue?vue&type=template&id=c281c948"
import script from "./tdpcontactrptfrm.vue?vue&type=script&lang=js"
export * from "./tdpcontactrptfrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports